<template>
    <form id="CertificateForm" class="needs-validation" novalidate>
        <div class="row g-3">
            <!-- Certificate Field -->
            <div class="col-md-4">
                <label for="certificateTypeId"><strong>{{ $Translate('certificate') }}: </strong><span
                        class="text-danger">*</span></label>
                <select class="form-control"
                    :class="{ 'is-valid': certSubmitted && certificateTypeIdIsValid, 'is-invalid': certSubmitted && !certificateTypeIdIsValid }"
                    id="certificateTypeId" v-model="certificate.certificateTypeId" required>
                    <option value="" selected disabled>{{ $Translate('selectCertificate') }}</option>
                    <option v-for="cert in certificatesList.filter(c => c.description != '')" :key="cert.recId"
                        :value="cert.recId">
                        {{ cert.description }}
                    </option>
                </select>
            </div>

            <!-- Unlisted Certificate Field -->
            <div class="col-md-4">
                <label for="unlistedCertificate"><strong>{{ $Translate('unlistedCertificate') }}:
                    </strong></label>
                <input type="text" id="unlistedCertificate" class="form-control"
                    :placeholder="$Translate('unlistedCertificatePlaceholder')"
                    :class="{ 'is-valid': certSubmitted && unlistedCertificateIsValid, 'is-invalid': certSubmitted && !unlistedCertificateIsValid }"
                    v-model="certificate.unlistedCertificate" name="unlistedCertificate" />
            </div>

            <!-- From Date Field -->
            <div class="col-md-4">
                <label for="startDateCertificate"><strong>{{ $Translate('startDate') }}: </strong><span
                        class="text-danger">*</span></label>
                <input type="date" id="startDateCertificate" class="form-control"
                    :class="{ 'is-valid': certSubmitted && startDateCertificateIsValid, 'is-invalid': certSubmitted && !startDateCertificateIsValid }"
                    v-model="certificate.startDateCertificate" name="startDateCertificate" />
            </div>

            <!-- To Date Field -->
            <div class="col-md-4">
                <label for="endDateCertificate"><strong>{{ $Translate('endDate') }}: </strong><span
                        class="text-danger">*</span></label>
                <input type="date" id="endDateCertificate" class="form-control"
                    :class="{ 'is-valid': certSubmitted && endDateCertificateIsValid, 'is-invalid': certSubmitted && !endDateCertificateIsValid }"
                    v-model="certificate.endDateCertificate" name="endDateCertificate" />
            </div>

            <!-- Description Field -->
            <div class="col-md-4">
                <label for="descriptionCertificate"><strong>{{ $Translate('description') }}:
                    </strong></label>
                <textarea id="descriptionCertificate" class="form-control"
                    :class="{ 'is-valid': certSubmitted && descriptionCertificateIsValid, 'is-invalid': certSubmitted && !descriptionCertificateIsValid }"
                    v-model="certificate.descriptionCertificate" name="descriptionCertificate" />
            </div>
        </div>

        <!-- Radio (Upload Type) -->
        <div class="d-flex align-items-center gap-4 mb-2">
            <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="certificateFile" value="file" v-model="certificate.certificateType"
                    class="custom-control-input" name="certificateType" />
                <label class="custom-control-label ms-2" for="certificateFile">{{ $Translate('uploadFile')
                }}</label>
            </div>

            <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="certificateURL" value="url" v-model="certificate.certificateType"
                    class="custom-control-input" name="certificateType" />
                <label class="custom-control-label ms-2" for="certificateURL">{{ $Translate('uploadUrl')
                }}</label>
            </div>
        </div>

        <!-- Label -->
        <div class="d-flex justify-content-start mb-2">
            <label><strong>{{ $Translate('certificate') }}:</strong></label>
        </div>

        <!-- File/URL Input -->
        <div class="mb-3">
            <div class="fileArea" v-if="certificate.certificateType === 'file'" style="background-color: white;">
                <input type="file" ref="fileInput" accept=".pdf" class="form-control" :class="{
                    'is-valid': certSubmitted && certificateUploadTypeIsValid,
                    'is-invalid': certSubmitted && !certificateUploadTypeIsValid
                }" @change="handleCertificateFileUpload" />
            </div>
            <div class="urlArea" v-if="certificate.certificateType === 'url'" style="background-color: white;">
                <input type="url" style="border: 0px; width: 100%;" :placeholder="$Translate('certificateLink')"
                    v-model="certificate.certificateLink" class="form-control" :class="{
                        'is-valid': certSubmitted && certificateUploadTypeIsValid,
                        'is-invalid': certSubmitted && !certificateUploadTypeIsValid
                    }" />
            </div>
        </div>
    </form>
</template>

<script>
export default {
    name: 'Certificates',
    props: {
        certificate: Object,
        certSubmitted: Boolean,
        certificateList: Array,
        certificateTypeIdIsValid: Boolean,
        unlistedCertificateIsValid: Boolean,
        startDateCertificateIsValid: Boolean,
        endDateCertificateIsValid: Boolean,
        descriptionCertificateIsValid: Boolean,
        certificateFileIsValid: Boolean,
        certificateURLIsValid: Boolean,
        certificateLinkIsValid: Boolean,
        certificateUploadTypeIsValid: Boolean,
        certificatesList: Array
    },
    methods: {
        handleCertificateFileUpload(event) {
            const file = event.target.files[0];
            if (file) {
                this.$emit('certificate-file-uploaded', file);
            }
        },
        resetFileInput() {
            this.$refs.fileInput.value = '';
        }
    }
}
</script>

<style scoped>
.col-md-4 {
    text-align: start;
}

.col-md-4 label {
    margin-bottom: 10px;
}

.col-md-4 input,
.col-md-4 select,
.col-md-4 textarea {
    margin-bottom: 12px;
}

.col-md-4 select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: url('../../../../dist/assets/select.svg') no-repeat right 0.75rem center;
    background-color: #fff;
    background-size: 16px 16px;
    padding-right: 2rem;
    line-height: 1.5;
    height: calc(1.5em + 0.75rem + 2px);
}

.fileArea,
.urlArea {
    margin-top: 2px;
    width: 100%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 10px;
    text-align: start;
}
</style>